import styled from 'styled-components'
import { LOGO_WIDTHS, MEDIA_QUERIES } from './media-queries'

export const PaypalLogoContainer = styled.div`
  display: inline-block;
  width: ${LOGO_WIDTHS.SMALL_MOBILE};
  height: auto;

  ${MEDIA_QUERIES.SMALLEST_MOBILE} {
    width: ${LOGO_WIDTHS.SMALLEST_MOBILE};
  }

  ${MEDIA_QUERIES.SMALL_MOBILE} {
    width: ${LOGO_WIDTHS.SMALL_MOBILE};
  }

  ${MEDIA_QUERIES.MEDIUM_MOBILE} {
    width: ${LOGO_WIDTHS.MEDIUM_MOBILE};
  }

  ${MEDIA_QUERIES.LARGE_MOBILE} {
    width: ${LOGO_WIDTHS.LARGE_MOBILE};
  }

  ${MEDIA_QUERIES.DESKTOP} {
    width: ${LOGO_WIDTHS.DESKTOP};
  }
`
